import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import {
  EntitiesSupportingHistory,
  EntityTypeSupportingHistory,
} from "@mapmycustomers/shared/types/entity";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import EntityHistoryModal from "@app/component/EntityHistoryModal";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./HistoryButton.module.scss";

interface Props {
  entity: EntitiesSupportingHistory;
  entityType: EntityTypeSupportingHistory;
}

const HistoryButton: React.FC<Props> = ({ entity, entityType }) => {
  const intl = useIntl();
  const analyticIssuer = useAnalytics();
  const [historyVisible, showHistory, hideHistory] = useBoolean(false);

  const handleShowHistory = useCallback(() => {
    analyticIssuer.clicked(["View Record History"]);
    showHistory();
  }, [analyticIssuer, showHistory]);

  return (
    <>
      <div className={styles.container}>
        <Button block className={styles.button} onClick={handleShowHistory}>
          {intl.formatMessage({
            id: "preview.entityHistorySow",
            defaultMessage: "View Record History",
            description: "Preview entity - show history button",
          })}
        </Button>
      </div>
      {historyVisible && (
        <EntityHistoryModal entity={entity} entityType={entityType} onHide={hideHistory} />
      )}
    </>
  );
};

export default HistoryButton;
